import React from 'react';
import { Hidden, makeStyles } from '@material-ui/core';
import { Button } from 'rsuite';
import bbImage from './images/foodpartners_bb_mobile.png';
import dBbImage from './images/banner_bb.jpg';
import titleImage from './images/title_mobile.png';
import featuresImage from './images/SP_features_mobile.png';
import spIconsImage from './images/icons_SPclients_mobile.png';
import dSpIconsImage from './images/icon_SPclients.png';
import spClientImage from './images/SPClients_moboile.png';
import dSpClientImage from './images/banner_SPclients.png';
import foodPicsImage from './images/foodpics_mobile.png';
import brandsBgImage from './images/partnerslogo_bg_mobile.png';
import dBrandsBgImage from './images/partnerslogo_bg.png';
import spBannerImage from './images/banner_SPclient_mobile.png';
import dSpBannerImage from './images/banner_SPclient1.png';
import aImage from './images/A.png';
import bImage from './images/B.png';
import cImage from './images/C.png';
import dImage from './images/D.png';
import eImage from './images/E.png';
import fImage from './images/F.png';

const useStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 14,
  },
  bbContainer: {
    alignItems: 'center',
    backgroundImage: `url(${bbImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    color: 'white',
    display: 'flex',
    fontSize: 32,
    fontWeight: 'bold',
    height: 228,
    justifyContent: 'center',
    padding: theme.spacing(3),
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      backgroundImage: `url(${dBbImage})`,
      height: 661,
    },
  },
  bbContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    [theme.breakpoints.up('sm')]: {
      alignItems: 'start',
      width: '100%',
      fontSize: 62,
      height: 661,
      maxWidth: 768,
    },
  },
  bbButton: {
    background: theme.palette.primary.main,
    borderRadius: 4,
    color: 'black',
    fontSize: 14,
    marginTop: theme.spacing(1),
    padding: theme.spacing(0.5, 3),

    [theme.breakpoints.up('sm')]: {
      fontSize: 28,
      marginTop: theme.spacing(3),
    },
  },
  bbDescription: {
    fontSize: 14,
    fontWeight: 'normal',
    [theme.breakpoints.up('sm')]: {
      fontSize: 24,
    },
  },
  content: {
    alignItems: 'center',
    color: '#4f4f4f',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      maxWidth: 768,
      fontSize: 16,
    },
  },
  contentTitle: {
    color: 'black',
    fontSize: 20,
    fontWeight: 'bold',

    [theme.breakpoints.up('sm')]: {
      fontSize: 40,
    },
  },
  contentBody: {
    marginTop: 12,
    color: '#4f4f4f',

    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
  },
  contentImages: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    padding: theme.spacing(5, 0),
    maxWidth: 768,

    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
  foodPicsContainer: {
    height: 508,
    position: 'relative',
    width: '100%',
  },
  foodPics: {
    backgroundImage: `url(${foodPicsImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: 508,
    padding: theme.spacing(3, 0),
    position: 'absolute',
    width: '100%',
    zIndex: 50,
  },
  foodPicsContent: {
  },
  planContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 'bold',
    justifyContent: 'center',
    paddingTop: theme.spacing(3, 0),
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      background: '#e9e9e9',
    },
  },
  planButtonContainer: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  planButton: {
    background: '#00a115',
    borderRadius: 4,
    color: 'white',
    fontSize: 27,
    padding: theme.spacing(0.5, 3),
  },
  planHeader: {
    border: 0,
    borderBottomWidth: 3,
    borderColor: 'black',
    borderStyle: 'solid',
    borderTopWidth: 3,
    boxSizing: 'border-box',
    fontSize: 20,
    padding: theme.spacing(1),
  },
  planBody: {
    fontSize: 35,
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      flexDirection: 'row',

      '& > * + *': {
        marginLeft: theme.spacing(2),
        display: 'flex',
      },
    },
  },
  planFooter: {
    marginTop: theme.spacing(3),
    fontSize: 30,

    [theme.breakpoints.up('sm')]: {
      fontSize: 35,
    },
  },
  planFirst: {
    fontSize: 24,
    '&::before': {
      content: '｜',
      position: 'absolute',
      width: '100%',
      top: 0,
      right: 0,
    },

    [theme.breakpoints.up('sm')]: {
      fontSize: 32,
    },
  },
  planSecond: {
    color: '#ffb120',
    fontSize: 42,
    [theme.breakpoints.up('sm')]: {
      fontSize: 60,
    },
  },
  planThird: {
    [theme.breakpoints.up('sm')]: {
      fontSize: 50,
    },
  },
  brandsContainer: {
    background: 'rgb(255,202,32)',
    height: 90,
    width: '100%',
  },
  brandsHeader: {
    alignItems: 'center',
    background: theme.palette.primary.main,
    display: 'flex',
    fontSize: 40,
    fontWeight: 'bold',
    height: 92,
    justifyContent: 'center',
    width: '100%',
  },
  brandsBody: {
    alignItems: 'center',
    backgroundImage: `url(${brandsBgImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 250,
    justifyContent: 'center',
    padding: theme.spacing(3),
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      backgroundImage: `url(${dBrandsBgImage})`,
    },
  },
  priceBg: {
    background: '#e9e9e9',
    bottom: 0,
    height: '15%',
    position: 'absolute',
    width: '100%',
  },
  featuresBg: {
    background: theme.palette.primary.main,
    height: '70%',
    position: 'absolute',
    width: '100%',
  },
}));

export default ({ formLink }) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div className={classes.bbContainer}>
        <div className={classes.bbContent}>
          <span>建立品牌專屬</span>
          <span>微型門市</span>
          <span className={classes.bbDescription}>從沒想過，可以離你這麼近</span>
          <Button
            className={classes.bbButton}
            target="_blank"
            href={formLink}
          >
            立即諮詢
          </Button>
        </div>
      </div>
      <div className={classes.content}>
        <img src={titleImage} alt="" width="100%" />
        <span className={classes.contentTitle} style={{ marginTop: 24 }}>建立品牌自有通路 輕鬆直面消費者</span>
        <Hidden xsDown>
          <div className={classes.contentImages}>
            <img src={aImage} alt="多元結帳/拆帳,電子支付金流透明" />
            <img src={bImage} alt="輕鬆多店管理,後台監控遠端管理" />
            <img src={cImage} alt="自動化銷售報表,線上線下消費全掌握" />
            <img src={dImage} alt="超低展店成本,0沈沒成本" />
            <img src={eImage} alt="多元應用服務,展售/派樣/員福/兌換/取貨" />
            <img src={fImage} alt="品牌體驗升級,直接與消費者溝通" />
          </div>
        </Hidden>
        <Hidden smUp>
          <img src={featuresImage} alt="" width="100%" style={{ marginTop: 24 }} />
        </Hidden>
      </div>
      <Hidden xsDown>
        <img src={dSpBannerImage} alt="" width="100%" style={{ marginTop: 24 }} />
      </Hidden>
      <Hidden smUp>
        <img src={spBannerImage} alt="" width="100%" style={{ marginTop: 24 }} />
      </Hidden>
      <div className={classes.planContainer}>
        <Hidden xsDown>
          <img
            alt=""
            src={dSpIconsImage}
            style={{ marginTop: 72, padding: '0 24px', maxWidth: 768 }}
            width="100%"
          />
        </Hidden>
        <Hidden smUp>
          <img src={spIconsImage} alt="" width="100%" style={{ marginTop: 24 }} />
        </Hidden>
        <div className={classes.planBody}>
          <span className={classes.planFirst}>
            0展店裝潢費用
          </span>
          <span className={classes.planFirst}>
            0展店前置時間
          </span>
          <span className={classes.planFirst}>
            免額外人力成本
          </span>
        </div>
        <span className={classes.planFooter}>線下零售一手掌握</span>
        <div className={classes.planButtonContainer}>
          <Button
            className={classes.planButton}
            target="_blank"
            href={formLink}
          >
            請專人聯繫我

          </Button>
        </div>
        <div style={{
          marginTop: 60, background: 'rgb(92,92,92)', width: '100%', textAlign: 'center',
        }}
        >
          <Hidden xsDown>
            <img
              alt=""
              src={dSpClientImage}
              style={{ transform: 'translateY(-30px)', padding: '0 24px', maxWidth: 768 }}
              width="100%"
            />
          </Hidden>
          <Hidden smUp>
            <img
              alt=""
              src={spClientImage}
              style={{ transform: 'translateY(-30px)' }}
            />
          </Hidden>
        </div>
      </div>
      <div className={classes.brandsContainer} />
    </div>
  );
};
